import Axios from './axios'

export default new Axios()